













































import { Component, PropSync, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { MessageService } from "@/shared/services/message-service";
import { ProcessoNums } from "./ProcessoNums";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
@Component({
  components: {
    ConfirmDialog,
  },
})
export default class ProcesoRecepcionar extends Vue {
  @PropSync("id", { default: -1 }) id_prodcuto!: number;
  @PropSync("show", { default: false }) Xshow!: boolean;
  public selectedRow: producto = new producto();

  async created() {
    if (!(productoModule.productos.length > 0)) {
      await productoModule.getproductos();
    }
    this.selectedRow = productoModule.productos.find(
      (x) => x.id === this.id_prodcuto
    )!;

    await datos_adicionales_productoModule.getdatos_adicionales_productoById(
      this.selectedRow.id
    );
  }

  get datos_adicionales_base_de_datos() {
    return datos_adicionales_productoModule.datos_adicionales_producto;
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  async aceptar() {
    this.selectedRow.estado = ProcessoNums.Disponible;
    this.selectedRow.precio_vendido = 0;
    this.selectedRow.vendido = false;

    await datos_adicionales_productoModule.eliminardatos_adicionales_producto(
      this.datos_adicionales_base_de_datos
    );

    productoModule.modificarproducto(this.selectedRow).then(() => {
      this.cancelar();
      MessageService.toast("Producto Listo para la venta");
      productoModule.getproductos();
    });
  }
  cancelar() {
    this.Xshow = false;
  }
}
